import { render, staticRenderFns } from "./SidebarNavDropdownIS.vue?vue&type=template&id=23eb6f58&scoped=true"
import script from "./SidebarNavDropdownIS.vue?vue&type=script&lang=js"
export * from "./SidebarNavDropdownIS.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavDropdownIS.vue?vue&type=style&index=0&id=23eb6f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb6f58",
  null
  
)

export default component.exports